export const COUPON_TYPE = {
    ITEM_SPECIFIC: "지정 발행",
    GENERIC: "미지정 발행",
} as const;

export const COUPON_TYPE_EXTENDED = {
    ITEM_SPECIFIC: "지정 발행",
    GENERIC: "미지정 발행",
    AUTO_ISSUED: "자동 발행",
} as const;
